export const GET_APPLESMSFIX = "GET_APPLESMSFIX";
export const GET_APPLESMSFIX_SUCCESS = "GET_APPLESMSFIX_SUCCESS";
export const GET_APPLESMSFIX_FAIL = "GET_APPLESMSFIX_FAIL";

export const ADD_APPLESMSFIX_SUCCESS = "ADD_APPLESMSFIX_SUCCESS";
export const ADD_APPLESMSFIX_FAIL = "ADD_APPLESMSFIX_FAIL";
export const UPDATE_APPLESMSFIX_SUCCESS = "UPDATE_APPLESMSFIX_SUCCESS";
export const DELETE_APPLESMSFIX_SUCCESS = "DELETE_APPLESMSFIX_SUCCESS";
